import { safeDefineElement } from '@/scripts/core/global'

import { FacetFiltersForm, beforeFacetFiltersForm, afterFacetFiltersForm } from '@/scripts/catalog/facet-filters-form'
import { PriceRange } from '@/scripts/catalog/price-range'
import { FacetRemove } from '@/scripts/catalog/facet-remove'
import { MainSearch } from '@/scripts/catalog/main-search'

safeDefineElement(FacetFiltersForm, beforeFacetFiltersForm, afterFacetFiltersForm)
safeDefineElement(PriceRange)
safeDefineElement(FacetRemove)
safeDefineElement(MainSearch)
